module.exports = __webpack_public_path__ + "img/6f406e6.jpg";